import { Icon } from '#/components/Icon/Icon';
import {
  IndicatorHeadline,
  IndicatorIconWrapper,
  LargeIndicatorBase,
  SmallIndicatorBase,
  SmallIndicatorIconHolder,
} from '#/components/Indicator/Indicator.styled';
import type {
  IndicatorProps,
  LargeIndicatorProps,
  SmallIndicatorProps,
} from '#/components/Indicator/types';

export const IndicatorIconSizes = {
  medium: 16,
  large: 24,
} as const;

const renderSmallIndicator = ({
  variant = 'default',
  iconName,
  iconSize = 'medium',
  children,
}: SmallIndicatorProps) => (
  <SmallIndicatorBase $variant={variant}>
    {iconName && (
      <SmallIndicatorIconHolder>
        <Icon name={iconName} size={IndicatorIconSizes[iconSize]} />
      </SmallIndicatorIconHolder>
    )}
    <div>{children}</div>
  </SmallIndicatorBase>
);

const renderLargeIndicator = ({
  variant = 'default',
  children,
  headline,
  icon,
}: LargeIndicatorProps) => (
  <LargeIndicatorBase $variant={variant}>
    {icon ? <IndicatorIconWrapper>{icon}</IndicatorIconWrapper> : null}
    <div>
      {headline ? <IndicatorHeadline>{headline}</IndicatorHeadline> : null}
      <div>{children}</div>
    </div>
  </LargeIndicatorBase>
);

export function Indicator(props: IndicatorProps) {
  if (props.size === 'large') return renderLargeIndicator(props);
  return renderSmallIndicator(props);
}
